export const shuffleArray = <T>(toShuffle: T[]) => {
  const array = [...toShuffle];

  for (let i = array.length - 1; i > 0; i--) {
    // Generate a random index from 0 to i
    const j = Math.floor(Math.random() * (i + 1));

    // Swap elements at i and j
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

export const sumAll = (numbers: number[]) => {
  return numbers.reduce((previousValue, currentValue) => {
    return previousValue + currentValue;
  }, 0);
};

export const multiplyAll = (numbers: number[]) => {
  return numbers.reduce((previousValue, currentValue) => {
    return previousValue * currentValue;
  }, 1);
};
